export default {
  setList(state, list) {
    state.list = [...state.list, ...list];
  },

  initList(state) {
    state.page = 1;
    state.totalPage = 2;
    state.list = [];
  },

  setPage(state, page = 1) {
    state.page = page;
  },

  setTotalPage(state, totalPage = 2) {
    state.totalPage = totalPage;
  },

  setPageInfo(state, pageInfo) {
    state.pageInfo = pageInfo;
  }
};
